import { EspAccount } from 'modules/graphql/types';
import { SmsSender } from 'modules/sendingPlatforms/types';
import {
  MODAL_ACTION,
  useModalsContext,
  CreateAccountFormProvider,
  EditAccountFormProvider,
  useSendingPlatformsQueryContext,
  CreateSmsSenderFormProvider,
  EditSmsSenderFormProvider,
} from '../../../contexts';
import { ITERABLE_SMS, TWILIO, TELNYX, ConfigurableSendingPlatforms } from '../../../constants';
import { AddSmsSenderModal } from './SmsSenders/AddSmsSenderModal';
import { EditSmsSenderModal } from './SmsSenders/EditSmsSenderModal';
import { DisconnectAccountModal } from '../Shared/DisconnectAccountModal';
import { AddVerificationProfileModal } from './VerificationProfiles/AddVerificationProfileModal';
import { DeleteSmsSenderModal } from './SmsSenders/DeleteSmsSenderModal';
import {
  IterableSmsCreateModal,
  IterableSmsEditModal,
  TelnyxCreateModal,
  TelnyxEditModal,
  TwilioCreateModal,
  TwilioEditModal,
} from './Modals';

export const CreateModalBySendingPlatform = {
  [TWILIO]: TwilioCreateModal,
  [TELNYX]: TelnyxCreateModal,
  [ITERABLE_SMS]: IterableSmsCreateModal,
};

export const EditModalBySendingPlatform = {
  [TWILIO]: TwilioEditModal,
  [TELNYX]: TelnyxEditModal,
  [ITERABLE_SMS]: IterableSmsEditModal,
};

export const SmsModals = () => {
  const { modalState } = useModalsContext();
  const { selectEspAccount, espDefinitions } = useSendingPlatformsQueryContext();

  if (modalState === null) return null;

  const { action, smsSender } = modalState;
  const sendingPlatform = modalState.sendingPlatform as ConfigurableSendingPlatforms;
  const espAccountId = modalState.espAccountId as number;
  const espAccount = selectEspAccount(espAccountId) as EspAccount;

  switch (action) {
    case MODAL_ACTION.CREATE_ACCOUNT_INTEGRATION: {
      const CreateModal =
        CreateModalBySendingPlatform[sendingPlatform as keyof typeof CreateModalBySendingPlatform];
      return (
        <CreateAccountFormProvider
          sendingPlatform={sendingPlatform}
          espDefinitions={espDefinitions}
        >
          <CreateModal />
        </CreateAccountFormProvider>
      );
    }

    case MODAL_ACTION.EDIT_ACCOUNT_INTEGRATION: {
      const EditModal =
        EditModalBySendingPlatform[sendingPlatform as keyof typeof EditModalBySendingPlatform];
      return (
        <EditAccountFormProvider espAccount={espAccount}>
          <EditModal />
        </EditAccountFormProvider>
      );
    }

    case MODAL_ACTION.DISCONNECT_ACCOUNT:
      return <DisconnectAccountModal espAccountId={espAccountId} />;

    case MODAL_ACTION.ADD_SMS_SENDER:
      return (
        <CreateSmsSenderFormProvider espAccountId={espAccountId}>
          <AddSmsSenderModal espAccountId={espAccountId} />
        </CreateSmsSenderFormProvider>
      );
    case MODAL_ACTION.EDIT_SMS_SENDER:
      return (
        <EditSmsSenderFormProvider smsSender={smsSender as SmsSender}>
          <EditSmsSenderModal smsSender={smsSender as SmsSender} />
        </EditSmsSenderFormProvider>
      );
    case MODAL_ACTION.DELETE_SMS_SENDER:
      return <DeleteSmsSenderModal smsSender={smsSender as SmsSender} />;

    case MODAL_ACTION.ADD_VERIFICATION_PROFILE:
      return <AddVerificationProfileModal espAccountId={espAccountId} />;

    default:
      return null;
  }
};
